module.exports = __webpack_public_path__ + "img/edit.c339a976.svg";